import { httpClientOmni } from "@/libraries";

export default {
  get(payload) {
    return httpClientOmni.get("/chat-template", {
      params: {
        per_page: 250,
        ...payload
      }
    });
  },
  create(payload) {
    return httpClientOmni.post("chat-template", payload);
  },
  update(payload){
    return httpClientOmni.post(`chat-template/${payload.id}/update`, payload);
  },
  delete(payload) {
    return httpClientOmni.get(`v3/chat-template/${payload.id}/delete`);
  },
  deleteMultiple(payload) {
    return httpClientOmni.delete(`chat-template?chatTemplateId=${payload.chatTemplateId}`);
  }
};
